import { render, staticRenderFns } from "./CargoExpenseOccurrenceCreate.vue?vue&type=template&id=338868e5"
import script from "./CargoExpenseOccurrenceCreate.vue?vue&type=script&lang=js"
export * from "./CargoExpenseOccurrenceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports